import { Environment } from '.';
import { deviceSupportsResource } from './deviceSupportsResource';

export function configureWindows(env: Environment) {
	env.initializeSync = true;
	env.supportsResource = resource =>
		deviceSupportsResource(resource, 'application/windows');
}
